import { createContext } from 'react';

const reducer = createContext({
   state: {},
   dispatch: () => { }
});


export default reducer;